import { countries } from '../../../../lib/countries';

export type TicketGeofilteringMode = 'all' | 'include' | 'exclude' | null;

export interface TicketGeofilteringDisplay {
  label: string;
  summary: string;
  countryNames: string;
}

const countryNameByCode = new Map<string, string>(
  countries.map((country) => [country.code, country.name]),
);

export function getTicketGeofilteringDisplay(
  mode: TicketGeofilteringMode,
  availableCountries: readonly string[],
): TicketGeofilteringDisplay | null {
  if (
    (mode !== 'include' && mode !== 'exclude') ||
    availableCountries.length === 0
  ) {
    return null;
  }

  const countryNames = availableCountries
    .map((countryCode) => countryNameByCode.get(countryCode) ?? countryCode)
    .join(', ');
  const countryCount = availableCountries.length;

  if (mode === 'exclude') {
    return {
      label: 'Excluded countries',
      summary: `Unavailable in ${countryCount} ${countryCount === 1 ? 'country' : 'countries'}`,
      countryNames,
    };
  }

  return {
    label: 'Included countries',
    summary: `Available only in ${countryCount} ${countryCount === 1 ? 'country' : 'countries'}`,
    countryNames,
  };
}
